// B1237: which login failure means THE CREDENTIAL IS DEAD. It imports nothing.
//
// This was `socket.js`'s, and it still is — that file re-exports it, so its
// callers and `socket-auth.test.js` are unchanged. It moved here for the reason
// `./session-token.js` moved: the four demo pages need the same answer, and
// `socket.js` imports the console's auth store, so a demo cannot read it there.
// A second copy of "this message means log in again" is how the console and the
// demos start disagreeing about a dead token.

/**
 * `refused` = the credential presented is not one this server accepts.
 * `transient` = a timeout or a dropped socket, where a retry is the right answer.
 *
 * `Response::Error` carries no error KIND on the wire — `from_kinedb_error` keeps
 * only the message string — so the text is all there is to go on.
 *
 * An unrecognised failure defaults to `transient`, because logging a user out on
 * a message nobody anticipated is the more destructive of the two mistakes.
 */
export function classifyLoginFailure(e) {
  const msg = String(e?.message ?? e);
  // The single AUTH_FAILED string, used for a wrong password, an unknown user
  // and a malformed body alike.
  if (/invalid username or password/i.test(msg)) return 'refused';
  // The token path's refusal (`SESSION_REJECTED`): this node does not know
  // the persisted token — restarted / data reset, expired, or revoked.
  if (/session expired or revoked/i.test(msg)) return 'refused';
  return 'transient';
}
